<template>
  <div class="video-background">
    <div class="video-wrapper">
      <video autoplay muted loop playsinline>
        <source src="assets/videos/cyanhome.mp4" type="video/mp4" />
      </video>
    </div>
    <div class="content-wrapper">
      <img class="footer-clip" src="https://www.cyanwp.com/themes/cyan/assets/assets/icons-and-others/dde.svg" alt="Footer Clip" />
      <div class="centered-content">
        <h1 class="font-terbinado text-warning">{{ $t('hero.heading') }}</h1>
        <button class="book-tickets-btn" @click="bookTickets">
          {{ $t('button.buy_tickets') }}
        </button>
      </div>
    </div>
    
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
const bookTickets = () => {
  router.push('/tickets')
};
</script>

<style scoped>
.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.video-wrapper video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.footer-clip {
  position: absolute;
  bottom: 15%;
  left: 44%;
  top: auto;
  height: auto;
  max-height: 80px;
}

.centered-content {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 0 20px;
  width: 100%;
}

.centered-content h1 {
  font-size: 7rem;
  font-weight: 800;
  transform: rotate(-10deg);
  letter-spacing: 2px;
}

.book-tickets-btn {
  background: #efb036;
  color: white;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  z-index: 2;
}

.book-tickets-btn:hover {
  background: #cc0070;
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .centered-content h1 {
    font-size: 35px;
  }

  .book-tickets-btn {
    padding: 10px 20px;
    font-size: 14px;
  }

  .footer-clip {
    max-height: 100px;
  }
}

@media (max-width: 480px) {
  .centered-content h1 {
    font-size: 28px;
  }

  .book-tickets-btn {
    padding: 8px 16px;
    font-size: 12px;
  }

  .footer-clip {
    max-height: 80px;
  }
}
</style>